import { Languages } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

/** Icon-only, in the corner — the same treatment as the mobile header. */
export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const next = language === 'ar' ? 'en' : 'ar';
  return (
    <button
      type="button"
      aria-label={next === 'en' ? 'English' : 'العربية'}
      data-testid="language-switcher"
      onClick={() => setLanguage(next)}
      className="flex h-10 w-10 items-center justify-center rounded-full text-ink transition-colors hover:bg-surface focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    >
      <Languages className="h-5 w-5" strokeWidth={1.8} />
    </button>
  );
}
